<template>
  <div>
    <top-bar @changeEmpresa="changeEmpresa"/>
    <div class="content">
      <div class="lebot-welcome text-center">
        <div v-if="connectionBlocked" class="px-3">
          <p class="mb-0">Este número de WhatsApp já está em uso em outra sessão.</p>
          <p>Reinicie o aplicativo para conectar outro WhatsApp.</p>
          <button class="btn btn-sm btn-primary" v-if="isElectron" @click="reiniciar()">Reiniciar agora</button>
        </div>
        <div v-else>
          <loading v-if="!session"/>
          <p class="mt-4">Por favor aguarde, o Bot está sendo iniciado</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TopBar from "@/components/commons/TopBar";
import Loading from "@/components/commons/Loading";

export default {
  components: {Loading, TopBar},

  methods: {
    reiniciar() {
      window.control.fechar({ reiniciar: true });
    },
    changeEmpresa(wpp) {
      if (this.isElectron) {
        window.control.toggleWpp({ wpp });
      }
    }
  },

  computed: {
    connectionBlocked() {
      const conta = this.empresas.find(empresa => empresa.isDefault);
      return !!conta && this.$store.state.blockedConnections.includes(conta.connectionId || conta.key);
    },
    session() {
      return this.$store.state.session
    },

    empresas() {
      return this.$store.state.empresas
    }
  },

  mounted() {
    if (!this.isElectron) {
      //this.$router.push('/chamados');
    }
  }
}

</script>

<style scoped>
.lebot-welcome {
  height: calc(100vh - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
